module.exports = __webpack_public_path__ + "static/img/发展理念.d8f48a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/发展理念.png
// module id = Gg6X
// module chunks = 13